module.exports = {
	RECEIVE_USER_CREDIT: 'RECEIVE_USER_CREDIT',
	RECEIVE_USER_CREDIT_HISTORY: 'RECEIVE_USER_CREDIT_HISTORY',
	RECEIVE_ALL_CREDIT_TYPE: 'RECEIVE_ALL_CREDIT_TYPE',
	RESET_CREDITS_INFORMATION: 'RESET_CREDITS_INFORMATION'
}



// WEBPACK FOOTER //
// ./src/home/constants/CreditConstants.js